import { run } from '@ember/runloop';
import { Promise } from 'rsvp';
import { buildWaiter } from '@ember/test-waiters';

let waiter = buildWaiter('read-file');

export default async function readFile(file: File) {
  let token = waiter.beginAsync();

  let result = await new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onerror = () => run(() => reject);
    reader.onload = (event: Event) => run(() => resolve((event.target as any).result));
    reader.readAsText(file);
  });

  waiter.endAsync(token);

  return result;
}
